// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_xvn","cls2":"Reader-cls2_dRb Reader-cls1_xvn","fullWidth":"Reader-fullWidth_ajt"};